import React from "react";
import { cn } from "~/lib/cn";

interface SubheadingProps {
  as?: "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  className?: string;
  children: React.ReactNode;
}

export const Subheading = ({
  as: Tag = "h2",
  className,
  children,
  ...props
}: SubheadingProps & React.HTMLAttributes<HTMLElement>) => {
  return (
    <Tag
      className={cn(
        "mb-6 text-2xl font-semibold text-gray-800 dark:text-gray-200",
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Subheading;
